/**
 * BenchToolbar — search, status pills and the table / cards switch for the org-wide bench (demo /manage-team
 * header, /tables/data-tables toolbar).
 */
import React from 'react';
import { LayoutGrid, List } from 'lucide-react';
import { FilterPills, SearchBar, Toolbar } from '../../../components/ui/index.js';
import { LayoutSwitcher } from '../shared';
import type { BenchFilter } from '../shared';

export type BenchView = 'table' | 'cards';

const FILTERS: Array<{ key: BenchFilter; label: string }> = [
  { key: 'all', label: 'All' },
  { key: 'attention', label: 'Needs attention' },
  { key: 'assigned', label: 'Assigned' },
  { key: 'unassigned', label: 'Unassigned' },
  { key: 'paused', label: 'Paused' },
  { key: 'needs_setup', label: 'Needs setup' },
];

interface BenchToolbarProps {
  filter: BenchFilter;
  setFilter: (f: BenchFilter) => void;
  counts: Record<BenchFilter, number>;
  search: string;
  setSearch: (s: string) => void;
  view: BenchView;
  setView: (v: BenchView) => void;
}

export const BenchToolbar: React.FC<BenchToolbarProps> = ({
  filter,
  setFilter,
  counts,
  search,
  setSearch,
  view,
  setView,
}) => (
  <Toolbar
    search={<SearchBar value={search} onChange={setSearch} placeholder="Search name, role, skill, project…" />}
    pills={
      <FilterPills
        aria-label="Status"
        options={FILTERS.map((f) => ({ id: f.key, label: f.label, count: counts[f.key] }))}
        value={filter}
        onChange={(id) => setFilter(id as BenchFilter)}
      />
    }
    right={
      <LayoutSwitcher
        value={view}
        ariaLabel="Bench layout"
        onChange={setView}
        options={[
          { value: 'table', label: 'Table', icon: List },
          { value: 'cards', label: 'Cards', icon: LayoutGrid },
        ]}
      />
    }
  />
);
